import { render, staticRenderFns } from "./ClubChannels.vue?vue&type=template&id=495d5c3d&scoped=true"
import script from "./ClubChannels.vue?vue&type=script&lang=js"
export * from "./ClubChannels.vue?vue&type=script&lang=js"
import style0 from "./ClubChannels.vue?vue&type=style&index=0&id=495d5c3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d5c3d",
  null
  
)

export default component.exports